import React from "react";
import { Container, Row, Col } from "reactstrap";
import appConfig from "../data/appConfig";
// get our fontawesome imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faPhone, faFax, faEnvelope } from "@fortawesome/free-solid-svg-icons";

//const siteURL = appConfig["siteSet"]["link"];
const siteTitle = appConfig["siteSet"]["title_c"];
const contactUsLink = appConfig["pageSet"]["contactUsLink"];

const copyrightStart = "1996";
const thisDay = new Date();
const copyrightThisYear = thisDay.getFullYear();

const Footer = () => {
	return (
		<Container fluid={true} className="site-footer">
			<Row>
				<Col xs="12">
					<a href="#" id="s2t"><span><i className="fa fa-chevron-up"></i></span></a>
					<p><span>Buddhist Association of the United States</span><br />
					<FontAwesomeIcon icon={faMapMarkerAlt} /> 2020, Route 301, Carmel, NY 10512<br />
					<FontAwesomeIcon icon={faPhone} /> 845-225-1819{" "}
					<FontAwesomeIcon icon={faFax} /> 845-228-4283{" "}
					<FontAwesomeIcon icon={faEnvelope} /> <a href={contactUsLink}>Contact Us</a><br />
					<span>&copy; Copyright  {copyrightStart} -{" "}
					{copyrightThisYear}{" "}{siteTitle}All Rights Reserved
					</span></p>
				</Col>
			</Row>
		</Container>
	);
};

export default Footer;
